module.exports = __webpack_public_path__ + "static/media/zaobao.69004420.svg";